<template>
  <div class="marker-container">
    <v-tooltip bottom v-for="div in divsToDisplay" :key="div.id">
      <template v-slot:activator="{ on }">
        <div
          class="d-flex flex-row"
          style="height: 100%"
          v-bind:style="{
            background: div.color,
            width: div.percentage * 100 + '%',
            'pointer-events': div.color === 'transparent' ? 'none' : 'auto'
          }"
          @click.stop="$emit('changeDate', div.date)"
          v-on="on"
        ></div>
      </template>
      <span>{{ div.tooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import moment from 'moment'
import { v4 as uuid } from 'uuid'

export default {
  name: 'CesiumMarkerOverlay',
  props: {
    startDate: {
      type: String
    },
    endDate: {
      type: String
    },
    markers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {
    divsToDisplay() {
      const markerWidth = 0.003
      const markersWithPercentage = this.markers
        .filter(
          (marker) =>
            marker.date >= this.startDate && marker.date <= this.endDate
        )
        .map((marker) => ({
          ...marker,
          percentage: this.getPercentageFromDate(marker.date)
        }))
      markersWithPercentage.sort((a, b) => {
        if (a.percentage < b.percentage) {
          return -1
        } else if (a.percentage > b.percentage) {
          return 1
        } else {
          return 0
        }
      })
      const allDivs = []
      let currentPercentage = 0
      for (const marker of markersWithPercentage) {
        if (marker.percentage > currentPercentage + markerWidth / 2) {
          allDivs.push({
            tooltip: '',
            color: 'transparent',
            date: '',
            percentage:
              marker.percentage - (currentPercentage + markerWidth / 2),
            id: uuid()
          })
        }
        allDivs.push({
          tooltip: marker.tooltip,
          color: marker.color,
          date: marker.date,
          percentage: markerWidth,
          id: uuid()
        })
        currentPercentage = marker.percentage + markerWidth / 2
      }
      return allDivs
    }
  },
  methods: {
    getPercentageFromDate(date) {
      const durationFromStart = moment
        .utc(date)
        .diff(moment.utc(this.startDate))
      const totalDuration = moment
        .utc(this.endDate)
        .diff(moment.utc(this.startDate))
      return durationFromStart / totalDuration
    }
  }
}
</script>

<style scope>
.marker-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  pointer-events: none;
  background: transparent;
}
</style>
